import request from 'utils/request';

const workSteps = {
  create: async (data) => await request.post('/processes/work_steps/', data),
  delete: async (workStepId) =>
    await request.delete(`/processes/work_steps/${workStepId}`),
  get: async (workStepId) =>
    await request.get(`/processes/work_steps/${workStepId}`),
  list: async () => await request.get('/processes/work_steps/'),
  update: async (workStepId, data) =>
    await request.patch(`/processes/work_steps/${workStepId}`, data),
};

const workflows = {
  create: async (data) => {
    const response = await request.post('/processes/workflows/', data);
    return response;
  },
  get: async (workflowId) => {
    const response = await request.get(`/processes/workflows/${workflowId}`);
    return response;
  },
  list: async (options) => {
    const response = await request.get('/processes/workflows/', options);
    return response;
  },
  update: async (workflowId, data) => {
    const response = await request.patch(
      `/processes/workflows/${workflowId}`,
      data,
    );
    return response;
  },
};

const processes = {
  listProcesses: async (groupId, query) =>
    await request.get(`/suppliers/${groupId}/processes`, {
      search: query,
    }),
};

export default {
  processes,
  workflows,
  workSteps,
};
